export const maqueta = {
    text1: "Sono stati effettuati",
    text2: "Check-in",
    text3: "Fogli di carta risparmiati 😊",
    text4: "Ogni 100 check-in piantiamo un albero con",
    text5: "ONE TREE PLANTED",
    text6: "Notifiche",
    text7: "Non hai notifiche",
    text8: "Vedi tutte",
    text9: "Benvenuto",
    text10: "Azienda",
    text11: "Tutti gli alloggi",
    text12: "Profilo",
    text13: "Esci",
    text14: "Spiacenti, si è verificato un errore durante la disconnessione",
    text15: "Il pagamento del tuo abbonamento è stato rifiutato",
    text16: "Per continuare a usare WACheckin devi completare il pagamento",
    text17: "Informazioni sul check-in",
    text18: "Dati del check-in",
    text19: "Data della richiesta:",
    text20: " alle",
    text21: "Dati raccolti durante il check-in dell'ospite",
    text22: "Nome",
    text23: "Cognome",
    text24: "Telefono",
    text25: "Data del soggiorno",
    text26: "Tipo di documento",
    text27: "Passaporto",
    text28: "Carta d'identità nazionale",
    text29: "Numero del documento",
    text30: "Informazioni aggiuntive",
    text31: "Scadenza del documento",
    text32: "Nazionalità",
    text33: "Data di nascita",
    text34: "Genere",
    text35: "Femmina",
    text36: "Maschio",
    text37: "Chiudi",
    text38: "Check-in",
    text39: "Richieste di servizio",
    text40: "Alloggi",
    text41: "Vendite incrociate",
    text42: "Integrazioni",
    text43: "Fatturazione",

    // Corrections
    p1: "Prenotazioni",

    // Plan validation corrections
    p2: `Aggiorna il tuo piano per effettuare i check-in`,
    p3: `Spiacenti, al momento non hai alcun abbonamento attivo o crediti per il tuo alloggio.`,
    p4: `Aggiorna piano`,

    p5: `I check-in non sono disponibili in questo alloggio.`,
    p6: `Per maggiori informazioni, contatta il proprietario della struttura.`,

    p7: `Account non verificato`,
    p8: `Controlla la tua casella di posta e conferma il tuo account. Non hai ricevuto l'email?`,
    p9: `Invia di nuovo`,
    p10: `Invio dell'email in corso, attendi...`,
    p11: `Il mio abbonamento`,

    p12: `Lingua e regione`,
    p13: `Scegli una lingua e una regione`,
    p14: `Qui puoi vedere tutti i check-in completati.`,
    p15: `Programma i tuoi check-in in anticipo e inviali ai tuoi ospiti.`,
    p16: `Qui troverai le richieste di servizio dei tuoi ospiti, come noleggi, tour e altro ancora.`,
    p17: `Invii massivi WhatsApp`,
    p18: `Collega il tuo account WhatsApp Business alla nostra piattaforma e abilita l'invio massivo di messaggi personalizzati ai tuoi ospiti in modo rapido e semplice, direttamente dal tuo numero ufficiale.`,
    p19: `Questa funzionalità è ancora in fase di sviluppo.`,
    p20: `Informazioni sul check-in`,

    p21: `Informazioni sul check-in`,
    p22: `Check-in associati`,
    p23: `Nessun check-in associato.`,
    p24: `Maggiori informazioni:`,
    p25: `Quale alloggio vuoi gestire?`,
    p26: ``,
    p27: ``,
    p28: ``,
    p29: ``,
    p30: ``,
    p31: ``,
};
